// extracted by mini-css-extract-plugin
export default {"productTitle":"ProductTitle_productTitle__Wuws+","newLabel":"ProductTitle_newLabel__IfIKO","productTitleDescription":"ProductTitle_productTitleDescription__40OgM"};